import React from 'react';
import GuestCuesheet from 'main/components/show/cuesheet.guest/cuesheet.jsx';

export default React.createClass({
  displayName: 'GuestPassShowPage',

  render() {
    const { type } = this.props.params;

    return (
      <div>
        <GuestCuesheet
          displayPageHeader
          displayFooter
          classes="guest-cuesheet"
          guest
          type={type}
        />
      </div>
    );
  },
});
